import isPropValid from '@emotion/is-prop-valid';

export function shouldForwardProp(propName, elementToBeRendered) {
    return typeof elementToBeRendered === 'string'
        ? isPropValid(propName) && !['height', 'width'].includes(propName)
        : true;
}
